import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { type ReportProblemBody, type ReportProblemResult, reportProblem } from '~/api/reportProblem';

export function useReportProblem(options?: UseMutationOptions<ReportProblemResult, Error, ReportProblemBody>) {
  return useMutation({
    mutationFn: (body: ReportProblemBody) => reportProblem(body),
    ...options,
  });
}
